exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.noFlex[data-v-13359866] {\n    flex-shrink: 0;\n    flex-grow: 0;\n}\n.textOverflowEllipsis[data-v-13359866] {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n", ""]);
